import React from "react";
import { ListGroupItem } from "react-bootstrap";
import SortIcon from '../../../components/Icons/SortIcon';

const RegistrationFieldsListItem = ({name}) => {
    return (
        <ListGroupItem
            style={{
                display: 'flex',
                columnGap: '20px',
            }}
        >
            <SortIcon />
            {name}
        </ListGroupItem>
    )
};

export default RegistrationFieldsListItem;
